// Angular
import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe, DecimalPipe } from '@angular/common';
import moment from 'moment';

@Pipe({
	name: 'sentDate'
})
export class SentDatePipe implements PipeTransform {

	constructor(
	) {
	}

	transform(value: string) {
        return this.getSentTime(value);
    }
	
	// ToDo #sbaleani: ver de donde sacar el Locate
    getSentTime(value: string): string{
		// uses UTC ISO Date format
		const createDate = moment.utc(value);
		const currentDate = moment().utc();

		var diffTime = createDate.diff(currentDate).valueOf();	

		if(-60*1000 < diffTime && diffTime <= 0){
			var decimalPipe = new DecimalPipe('en-US');
            return `hace ${decimalPipe.transform(-diffTime/1000, '1.0-0')} segundos`;
		}		
		else if(-60*60*1000 < diffTime && diffTime < 0){
			var decimalPipe = new DecimalPipe('en-US');
            return `hace ${decimalPipe.transform(-diffTime/1000/(60), '1.0-0')} minutos`;
		}
		else if (-24*60*60*1000 < diffTime && diffTime < 0) {
			var decimalPipe = new DecimalPipe('en-US');
            return `hace ${decimalPipe.transform(-diffTime/1000/(60*60), '1.0-0')} horas`;
		}
		else if (diffTime <= -24*60*60*1000){
			var datePipe = new DatePipe('en-US');
			return createDate.format('L LTS');
		}
		else if( diffTime > 0){
			return `mensaje desde el futuro: ${createDate}`
		}
	}
}